// extracted by mini-css-extract-plugin
module.exports = {"footerBox":"FooterWithPolicy-module-footerBox--KaN9X","logoWrapper":"FooterWithPolicy-module-logoWrapper--ZoArl","footerLink":"FooterWithPolicy-module-footerLink--UcHXh"};